// extracted by mini-css-extract-plugin
export default {"scrollingView":"Home__scrollingView___SH1AI"};